import React, { useState , useEffect} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import GlobalNav from '../../globalComponents/GlobalNav';
import Footer from '../../globalComponents/Footer';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [fmessage, setFmessage] = useState('');
  const [smessage, setSmessage] = useState('');
  const [vcode, setVcode] = useState('');
  const [newpassword, setNewPassword] = useState('');
  const [cooldown, setCooldown] = useState(0); // seconds the submit button stays disabled
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Get the email from the state
    const { state } = location;
    if (state && state.email) {
      setEmail(state.email);
    } else {
      // If email is not in state, redirect to login
    
      navigate('/login');
    }
  }, [location, navigate]);


  const COOLDOWN_KEY = 'pce_iam_reset_cooldown_until';
  const COOLDOWN_SECONDS = 60;

  // Restore any cooldown still running from a previous submit, so it holds
  // even after navigating away and coming back (or reloading the page).
  useEffect(() => {
    const until = parseInt(localStorage.getItem(COOLDOWN_KEY) || '0', 10);
    const remaining = Math.ceil((until - Date.now()) / 1000);
    if (remaining > 0) setCooldown(remaining);
  }, []);

  // Count the cooldown down to 0, re-enabling the button
  useEffect(() => {
    if (cooldown <= 0) return;
    const timer = setInterval(() => {
      setCooldown((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [cooldown]);

  // Disable the button for `seconds` and persist the expiry so it survives
  // navigation / reload.
  const startCooldown = (sec) => {
    localStorage.setItem(COOLDOWN_KEY, String(Date.now() + sec * 1000));
    setCooldown(sec);
  };

  // Display helper: mm:ss for >= 60s, otherwise "30s"
  const fmtTime = (s) =>
    s >= 60 ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}` : `${s}s`;

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Hard guard using the persisted timestamp so the cooldown holds across
    // navigation/remount (component state alone resets on a fresh mount).
    const until = parseInt(localStorage.getItem(COOLDOWN_KEY) || '0', 10);
    if (until > Date.now()) {
      setCooldown(Math.ceil((until - Date.now()) / 1000));
      return;
    }

    setFmessage('');
    setSmessage('');

    // Start the normal per-click cooldown (timer counts down on the button).
    startCooldown(COOLDOWN_SECONDS);

    try {
      const response = await fetch('/pceapi/auth/iamuser/reset', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email , vcode, newpassword}),
      });

      // Rate limited (too many requests): lock the button for the remaining
      // time the server reports via Retry-After.
      if (response.status === 429) {
        const retryAfter = parseInt(response.headers.get('Retry-After') || '0', 10);
        if (retryAfter > 0) startCooldown(retryAfter);
      }

      const data = await response.json();

      if (data.status === 'success') {
        setSmessage(data.message);
        //const passmessage = data.message;
        //navigate('/login', { state: { passmessage } });
      } else {
        setFmessage(data.message || 'An error occurred');
      }
    } catch (error) {
      setFmessage('An error occurred. Please try again.');
    }
  };

  return (
    <div className="main-window">
    <div className="container">
        <div className="auth-nav-bottom-margin">
        <GlobalNav/>
      </div>
      <div className="col-xl-5 col-lg-6 col-md-7 col-sm-10 mx-auto">
      <div className="text-center">
            <p className="ev-med-p-dark mb-2">Reset password</p>
            <p className="ev-message-card2 mb-4 rounded p-2">Enter the verification code received at your email address, followed by your new password.</p>
          </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                <label className="ev-reg-p-dark mb-1 mt-3">Email</label>
                <input id="email-address" name="email" type="email" autoComplete="email" className="formField3" placeholder="E.g. john@bms.com" value={email} onChange={(e) => setEmail(e.target.value)} disabled required/>
                <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 p-3">
                        <label className="ev-reg-p-dark mb-1 mt-3">Verification code</label>
                        <input className="formField3"type="text" id="vcode" name="vcode"value={vcode} onChange={(e) => setVcode(e.target.value)}required/>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 p-3">
                        <label className="ev-reg-p-dark mb-1 mt-3">Set new password</label>
                        <input className="formField2"type="password" id="newpassword" name="newpassword" value={newpassword} onChange={(e) => setNewPassword(e.target.value)} required/>
                    </div>
                </div>
              <div className="text-end"> 
                
                <button type="submit" disabled={cooldown > 0} className="ev-btn-blue-fill-round ev-btn-med ev-bold-reg" style={{opacity: cooldown > 0 ? 0.6 : 1, cursor: cooldown > 0 ? 'not-allowed' : 'pointer'}}>
                  {cooldown > 0 ? `Please wait ${fmtTime(cooldown)}` : <>Reset password <i className="bi bi-chevron-right"></i></>}
                </button>
              </div>
        </form>
        {fmessage && (
          <div className="mt-3 alert alert-danger">
            {fmessage}
          </div>
        )}
          {smessage && (
          <div className="mt-3 ev-alert-card-success d-flex align-items-center justify-content-between gap-3">
            <span>{smessage}</span>
            <button type="button" onClick={() => navigate('/login')} className="ev-btn-blue-outline-round ev-btn-med ev-bold-reg text-nowrap">
              Go to login <i className="bi bi-chevron-right"></i>
            </button>
          </div>
          )}
      </div>
      
    </div>
       <Footer/>
    </div>
  );
};

export default ResetPassword;